import { CardTypes, GridColumns, MediaTypes } from '@/types/enums'
import CardGrid from './CardGrid'
import { CardProps } from '@/components/molecules/card'
import { generateImageData } from '@/components/atoms/media/umbracoMediaElementPropsFactory'
import { GetUmbracoBaseUrl } from '@/utils/urlHelpers'
import { mappedGridColumns } from '@/utils/mappingHelpers'

function linkDownloadGridBlock(data: any, key: string | number): JSX.Element {
  const content = data?.content?.properties
  const mappedItems: CardProps[] = []

  content.items?.items?.map((item: any) => {
    const content = item?.content?.properties
    const mediaItemProps = generateImageData(
      { image: [content?.media?.[0]] },
      GetUmbracoBaseUrl(),
    )

    if (!!mediaItemProps && mediaItemProps?.type !== MediaTypes.Image) {
      throw new Error('Something other than an image passed')
    }

    const link = content?.link?.[0]
    const isDownload = link?.linkType === 'Media' ? true : false
    const urlOrPath = link?.url ?? link?.route?.path
    const url = isDownload ? GetUmbracoBaseUrl() + urlOrPath : urlOrPath

    mappedItems.push({
      cardType: CardTypes.Default,
      title: content?.title,
      text: content?.text,
      tag: content?.tag?.[0],
      mediaData: mediaItemProps,
      link: {
        url: url,
        isDownloadLink: isDownload,
        target: content?.link?.[0]?.target,
      },
    })
  })

  return (
    <CardGrid
      key={`cardgrid-${key}`}
      title={content?.title?.markup}
      items={mappedItems}
      gridColumns={mappedGridColumns(content.gridColumns)}
    />
  )
}
export default linkDownloadGridBlock
